import AboutPage from "./aboutPage";
import CapabilitiesPage from "./capabilitiesPage";
import ContactPage from "./ContactPage";
import CookieConsent from "./cookieConsent";
import LandingPage from "./landingPage";
import Layout from "./layout";
import Sitemap from "./sitemap";
import TestimonialsPage from "./testimonialsPage";

const Pages = {
  Layout,
  LandingPage,
  AboutPage,
  CapabilitiesPage,
  TestimonialsPage,
  ContactPage,
  CookieConsent,
  Sitemap,
};
export default Pages;
